import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
MiddlewareRegistry.register(store => next => (action) => {
    const result = next(action);
    switch (action.type) {
    }
    return result;
});
